/* eslint-disable prefer-const */
import { useMediaQuery, useTheme } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { ApiActions } from '@orientaction/api-actions';
import { backgroundChart, getFromLS, isAdmin, publicIconPath } from '@orientaction/utils';
import { kebabCase } from 'lodash';
import cloneDeep from 'lodash/cloneDeep';
import groupBy from 'lodash/groupBy';
import map from 'lodash/map';
import round from 'lodash/round';
import sumBy from 'lodash/sumBy';
import { FC, useEffect, useMemo, useState } from 'react';
import { Pie } from 'react-chartjs-2';
import ReactHtmlParser from 'react-html-parser';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ShareIcons from './ShareIcons';
import style from './style';

interface IProps {
  userResponse: any;
  showMainTitle?: boolean;
  showRestitutionTitle?: boolean;
  showRestitutionText?: boolean;
  sendDataMax?: (data: any) => void;
}

const colors = ['#F9BC5D', '#BB3570']; // [valeur forte, valeur faible]

const textColors = ['#000', '#fff']; // Texte adapté aux nouvelles couleurs

const SimplePie: FC<IProps> = ({
  userResponse,
  showMainTitle = true,
  showRestitutionTitle = true,
  showRestitutionText = true,
  sendDataMax,
}) => {
  const [linkCopied, setLinkCopied] = useState(false);
  const classes = style();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const dispatch = useDispatch();
  const history = useHistory();

  // Helper function to strip HTML tags
  const stripHtml = (html: string) => {
    const tmp = document.createElement('DIV');
    tmp.innerHTML = html || '';
    return tmp.textContent || tmp.innerText || '';
  };

  let allVariables: any[] = [];
  userResponse?.attributes?.responses?.data.forEach((response: any) => {
    response?.attributes.variable.data.forEach((variable: any) => {
      allVariables.push({
        ...variable,
        variableValue: response.attributes.variableValue, // Attribuer variableValue à chaque variable
      });
    });
  });
  const variableGroup = groupBy(allVariables, (variable: any) => variable.id);

  /* const variableGroup = groupBy(userResponse?.attributes.responses.data, (response: any) => {
    return response.attributes.variable.data.id;
  }); */

  /* const dataMapValue = map(variableGroup, (response: any) => {
    const sumVariable = sumBy(response, (variable: any) => variable.attributes.variableValue);
    const background = cloneDeep(backgroundChart);
    const idStyle = Math.floor(Math.random() * background.length);
    const dataBeforeRemove = {
      value: sumVariable,
      label: response[0].attributes.variable.data.attributes.name,
      image: response[0].attributes.variable.data.attributes.image,
      description: response[0].attributes.variable.data.attributes.description,
      bg: background[idStyle]?.bg,
      bd: background[idStyle]?.bd,
    };

    return dataBeforeRemove;
  }); */

  const dataMapValue = map(variableGroup, (variables: any[]) => {
    const sumVariable = sumBy(variables, (variable: any) => variable.variableValue);
    const firstVariable = variables[0];
    const background = cloneDeep(backgroundChart);
    const idStyle = Math.floor(Math.random() * background.length);

    return {
      value: sumVariable,
      label: stripHtml(firstVariable.attributes.title),
      title: firstVariable.attributes.title,
      image: firstVariable.attributes.image,
      video: firstVariable.attributes.video,
      typeMedia: firstVariable.attributes.typeMedia,
      description: firstVariable.attributes.description,
      bg: background[idStyle]?.bg,
      bd: background[idStyle]?.bd,
    };
  });

  // const totalValue = sumBy(dataMapValue, (value: any) => value.value) || 0;
  const totalValue = sumBy(dataMapValue, (item: any) => item.value) || 0;

  const dataMapValuePourcentage = dataMapValue
    .sort((a: any, b: any) => b.value - a.value)
    .map((item: any, index: number) => {
      const valuePercent = (item.value * 100) / totalValue;
      return {
        ...item,
        value: round(valuePercent, 2),
        color: colors[index % colors.length],
        bg: colors[index],
        txtColor: textColors[index],
      };
    });

  /*  const dataMapValuePourcentage = map(
    dataMapValue.sort((a: any, b: any) => b.value - a.value),
    (value: any, index: number) => {
      const valuePercent = (value.value * 100) / totalValue;
      const valueLabel = value.label;
      return {
        value: round(valuePercent),
        label: valueLabel,
        description: value?.description,
        image: value?.image,
        color: colors[index],
        bg: colors[index],
        txtColor: textColors[index],
      };
    }
  );
*/
  const maximumResponse = useMemo(() => dataMapValuePourcentage[0], [dataMapValuePourcentage]);

  // Send data to parent component
  useEffect(() => {
    if (sendDataMax && maximumResponse) {
      sendDataMax(maximumResponse);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userResponse]);

  const processedData = {
    datasets: [
      {
        labels: dataMapValuePourcentage.map((i: any) => i.label),
        data: dataMapValuePourcentage.map((i: any) => i.value),
        backgroundColor: dataMapValuePourcentage.map((i: any) => i.bg),
        borderColor: dataMapValuePourcentage.map((i: any) => i.bg),
        borderWidth: 0,
        datalabels: {
          labels: {
            name: {
              align: 'end' as const,
              anchor: 'end' as const,
              color: 'white',
              font: {
                size: 50,
                family: 'Poppins',
              },
              display: false,
              clamp: false,
              clip: false,
            },
          },
        },
      },
    ],
    // labels: data.map((i: any) => i.label),
  };

  const copyTestLink = () => {
    navigator.clipboard.writeText(testUrl);
    setLinkCopied(true);
  };

  const redirect = () => {
    dispatch(ApiActions.setTabLayout(1 as any));
    history.push('/user/tests');
  };

  const test = userResponse?.attributes?.test?.data;
  const testUrl = `${process.env.REACT_APP_SHARE_ENDPOINT}/api/test/${test.id}/${kebabCase(
    test.attributes.resultTitle || test.attributes.title
  )}`;
  const user = JSON.parse(getFromLS('userInfos') || '');

  return (
    <Grid className={classes.simplePieContainer} container={true} alignItems="center">
      <Grid item={true}>
        <div className={classes.diagramContainer} style={{ flexWrap: 'nowrap', gap: 24 }}>
          <div
            style={{ display: 'flex', justifyContent: 'center', width: 'auto', flex: '0 0 auto' }}
            className={classes.pieChart}>
            <Pie
              width={206}
              height={206}
              data={processedData}
              options={{
                responsive: false,
                plugins: {
                  tooltip: {
                    enabled: false,
                  },
                  datalabels: {
                    display: true,
                    color: (context: any) => {
                      const index = context.dataIndex;
                      return index < 2 ? '#000000' : '#ffffff';
                    },
                    clip: true,
                    labels: {
                      title: {
                        font: {
                          weight: 'bold',
                          size: 11.5,
                        },
                        align: 'center',
                        padding: 0,
                      },
                    },
                    formatter(value: any) {
                      return `${value}%`;
                    },
                  },
                },
                layout: {
                  padding: 0,
                },
                maintainAspectRatio: false,
              }}
            />
          </div>
          <div
            style={
              isMobile
                ? { paddingTop: 12 }
                : {
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignSelf: 'flex-start',
                    flex: 1,
                    minWidth: 0,
                    paddingTop: 12,
                  }
            }
            className={classes.labelsContainer}>
            {dataMapValuePourcentage?.map((elem: any) => (
              <div
                key={elem.label}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: isMobile ? 0 : 12,
                }}
                className={classes.labelItem}>
                <div
                  style={{
                    height: 22,
                    width: 32,
                    backgroundColor: elem.bg,
                    borderRadius: 4,
                    marginRight: 12,
                    flexShrink: 0,
                  }}
                />
                <span
                  style={{
                    color: '#0E1247',
                    fontWeight: 500,
                    fontSize: 12,
                    whiteSpace: 'normal',
                    wordWrap: 'break-word',
                    flex: 1,
                    marginTop: 5,
                    minWidth: 0,
                  }}>
                  {elem.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </Grid>
      <Grid className={classes.resultDetailsContainer} item={true} xs={12} md={6}>
        {showRestitutionTitle && (
          <Typography variant="h3" className={classes.textH3} style={{ color: '#151528' }}>
            {ReactHtmlParser(dataMapValuePourcentage.length && maximumResponse.title)}
          </Typography>
        )}
        {showRestitutionText && (
          <p
            className={classes.text}
            dangerouslySetInnerHTML={{
              __html: maximumResponse ? maximumResponse.description : 'En attente...',
            }}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default SimplePie;
